import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M7.25 9L7.25 6C7.25 5.30964 7.80964 4.75 8.5 4.75H15.5C16.1904 4.75 16.75 5.30964 16.75 6V9M7.25 15V18C7.25 18.6904 7.80964 19.25 8.5 19.25H15.5C16.1904 19.25 16.75 18.6904 16.75 18V15M4 12H20" vectorEffect="non-scaling-stroke" />
	</SVG>
);
